import React, { useEffect, useState } from "react";

import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import edit from "../../images/edit.svg";
import { UpdatePermissionModal } from "./adminComp/updatePermissionsModal";

function SuperAdminAllSupport({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentSupport, setCurrentSupport] = useState({});
  const [selectedAdmin, setSelectedAdmin] = useState({});

  const [permissionModal, setPermissionModal] = useState(false);

  const getSupport = async () => {
    try {
      setLoader(true);
      let withstats = true;

      const res = await api.getSupportAdmin(withstats);
      // console.log(res);
      if (res?.success) {
        setData(res.support);
        let currentS = res.support.find(
          (d) => d?._id == adminStore?.admin?.admin?._id
        );
        setCurrentSupport(currentS);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSupport();
  }, []);

  const openPermissionModal = (item) => {
    setSelectedAdmin(item);
    setPermissionModal(true);
    console.log(item);
  };
  const handleClose = () => setPermissionModal(false);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  All Support ({data?.length || 0})
                </h4>
                {/* {currentSupport?.role == "sackAdmin755" && (
                  <div className="updateStatus">
                    <Form>
                      <Form.Check
                        type="switch"
                        label="Online"
                        onChange={(e) => hanldeEdit(e)}
                        checked={currentSupport?.online ? true : false}
                        className="cursor-pointer"
                      />
                    </Form>
                  </div>
                )} */}
              </div>
            </div>
            {/* table */}
            <TableWithStats
              data={data}
              openPermissionModal={openPermissionModal}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
      <UpdatePermissionModal
        getData={getSupport}
        show={permissionModal}
        handleClose={handleClose}
        selectedData={selectedAdmin}
      />
    </>
  );
}
const Table = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const navigate = useNavigate();
  const THREE_MINUTES = 3 * 60 * 1000;

  const isOnline = (lastActiveAt) => {
    if (lastActiveAt) {
      return Date.now() - new Date(lastActiveAt).getTime() < THREE_MINUTES;
    } else {
      return false;
    }
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Name
                  </th>
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Last Active At
                  </th>
                  <th scope="col" className="">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.name}
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.email}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.lastActiveAt
                          ? formatDate(item?.lastActiveAt)
                          : "-"}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          isOnline(item?.lastActiveAt)
                            ? "badge bg-success"
                            : "badge bg-danger"
                        }
                      >
                        {isOnline(item?.lastActiveAt) ? "Online" : "Offline"}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
const TableWithStats = ({ data, openPermissionModal }) => {
  const THREE_MINUTES = 3 * 60 * 1000;

  const isOnline = (lastActiveAt) => {
    if (lastActiveAt) {
      return Date.now() - new Date(lastActiveAt).getTime() < THREE_MINUTES;
    } else {
      return false;
    }
  };
  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };
  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    name
                  </th>
                  <th scope="col" className="">
                    email
                  </th>
                  <th scope="col" className="">
                    Permissions
                  </th>
                  <th scope="col" className="">
                    Ticket Processing
                  </th>
                  <th scope="col" className="">
                    Ticket Closed
                  </th>
                  <th scope="col" className="">
                    Last Active At
                  </th>
                  <th scope="col" className="">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.name}
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.email}
                      </div>
                    </td>
                    <td>
                      <div className="text-right">
                        <img
                          src={edit}
                          alt="edit"
                          onClick={() => openPermissionModal(item)}
                          className="ms-2 cursor-pointer"
                        />
                      </div>
                      <div className="table-text-dark w-max-c db">
                        {item?.permissions ? (
                          <>
                            {item?.permissions.length > 0 ? (
                              <ul>
                                {item?.permissions.map((perm) => (
                                  <li key={perm}>{perm}</li>
                                ))}
                              </ul>
                            ) : (
                              "-"
                            )}
                          </>
                        ) : (
                          "-"
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark text-center db">
                        {item?.processedCount}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark text-center db">
                        {item?.closedCount}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.lastActiveAt
                          ? formatDate(item?.lastActiveAt)
                          : "-"}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          isOnline(item?.lastActiveAt)
                            ? "badge bg-success"
                            : "badge bg-danger"
                        }
                      >
                        {isOnline(item?.lastActiveAt) ? "Online" : "Offline"}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperAdminAllSupport;
